import loadScript from '@utils/loadScript';

import { userActions } from '@modules';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

export const setRiskifiedSessionId: TMiddleware = store => next => action => {
  const { user } = store.getState();
  const { sessionId } = user;

  if (checkActionsType(action, [userActions.getUserData.fulfilled]) && !sessionId) {
    const { data } = action.payload;
    if (data.session_id) {
      const domain = CONST.riskifiedDomainName;
      const { session_id } = data;
      const url = `https://beacon.riskified.com?shop=${domain}&sid=${session_id}`;

      loadScript(url);
    }
  }

  return next(action);
};

export default setRiskifiedSessionId;
